// extracted by mini-css-extract-plugin
module.exports = {"attribute-type-container":"inspector_attribute-type-container__1sEco"};